<div class="container">
    <div
        class="p-3"
        *ngIf="params.pendingData; else show"
    >
        <cmps-wait-status> </cmps-wait-status>
    </div>
    <ng-template #show>
        <div
            class="insight-backdrop-overlay"
            (click)="popUpService.hide()"
            *ngIf="popUpVisible"
        ></div>
        <div class="row">
            <div
                *ngIf="params.invalidUser"
                class="col-12"
            >
                <h6 class="alert alert-warning text-center">
                    The selected user is outside the hierarchy.
                </h6>
            </div>
            <div
                *ngIf="params.noData"
                class="col-12"
            >
                <h6 class="alert alert-warning text-center">
                    There is no data for the selected parameters.
                </h6>
            </div>
            <div
                *ngIf="params.invalidDate"
                class="col-12"
            >
                <h6 class="alert alert-warning text-center">
                    Please check the entered date.
                </h6>
            </div>

            <div class="mt-3 col-6">
                <div class="flex-form">
                    <label class="mr-3 mb-0"> Report Population </label>
                    <ng-select
                        [options]="reportPopulations"
                        [(ngModel)]="params.populationType"
                        (ngModelChange)="onSelectPopulationType()"
                        placeholder="Select Population"
                    ></ng-select>
                </div>
            </div>

            <div
                class="mt-3 col-6"
                [ngSwitch]="params.populationType"
            >
                <div class="flex-form">
                    <ng-container
                        *ngSwitchCase="TdReportPopulationType.SuperGroup"
                    >
                        <label class="mr-3 mb-0"> Select One </label>
                        <ng-select
                            [options]="superGroups"
                            [(ngModel)]="params.populationID"
                            placeholder="Select SuperGroup"
                        ></ng-select>
                    </ng-container>
                    <ng-container
                        *ngSwitchCase="TdReportPopulationType.PeerGroup"
                    >
                        <label class="mr-3 mb-0"> Select One </label>
                        <ng-select
                            [options]="peerGroups"
                            [(ngModel)]="params.populationID"
                            placeholder="Select PeerGroup"
                        ></ng-select>
                    </ng-container>
                    <ng-container
                        *ngSwitchCase="TdReportPopulationType.Individual"
                    >
                        <label class="mr-3 mb-0">Individual:&nbsp;</label>
                        <span class="f-s-75-2 form-value">{{
                            params.populationID?.userName
                        }}</span>
                        <button
                            (click)="onSelectUser($event)"
                            class="green btn-mini"
                        >
                            <cmps-icon svgIcon="pencil"></cmps-icon>
                        </button>
                    </ng-container>
                </div>
            </div>

            <div class="mt-3 col-6">
                <div class="flex-form">
                    <label
                        class="mr-3 mb-0"
                        for="reportDate"
                    >
                        {{ i18n._965_DATE | translate }}
                    </label>

                    <div class="input-group">
                        <input
                            id="reportDate"
                            class="form-control"
                            [(ngModel)]="params.date"
                            (ngModelChange)="onSelectDate()"
                            [placeholder]="i18n._646_YYYY_MM_DD | translate"
                            aria-labelledby="reportDate"
                            ngbDatepicker
                            [minDate]="minDate"
                            [maxDate]="maxDate"
                            #dp="ngbDatepicker"
                        />
                        <div class="input-group-append">
                            <button
                                type="button"
                                class="btn btn-secondary cmps-cdk-py-0dot5"
                                aria-label="Toggle date picker"
                                [attr.aria-expanded]="dp.isOpen()"
                                (click)="dp.toggle()"
                            >
                                <cmps-icon svgIcon="calendar"></cmps-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3 col-12">
                <button
                    class="btn btn-primary pull-right"
                    [disabled]="generateReportDisabled"
                    type="button"
                    (click)="onGenerateReport()"
                >
                    <cmps-icon svgIcon="file-document"></cmps-icon>
                    Generate Report
                </button>
            </div>
        </div>
    </ng-template>
</div>
